import { useEffect, useState, useRef, useCallback } from 'react';

const useCountdown = (timestamp, onExpire, useMilisecond = false) => {
  const [expiryTimestamp] = useState(timestamp);
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [miliseconds, setMiliseconds] = useState(0);

  const intervalRef = useRef();

  const reset = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    setSeconds(0);
    setMinutes(0);
    setHours(0);
    setDays(0);
  };

  useEffect(() => {
    reset();
  }, [timestamp]);

  const calculateExpiryDate = useCallback(() => {
    const now = new Date().getTime();
    const distance = timestamp - now;
    const tempdays = Math.floor(distance / (1000 * 60 * 60 * 24));
    const temphours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const tempminutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const tempseconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (tempseconds < 0) {
      if (onExpire) {
        reset();
        onExpire();
      }
    } else {
      setSeconds(tempseconds);
      setMinutes(tempminutes);
      setHours(temphours);
      setDays(tempdays);

      if (useMilisecond) {
        setMiliseconds(distance);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expiryTimestamp, onExpire, timestamp]);

  useEffect(() => {
    const start = () => {
      const isValidExpiryTimestamp = new Date(expiryTimestamp).getTime() > 0;

      if (isValidExpiryTimestamp && !intervalRef.current) {
        calculateExpiryDate();
        intervalRef.current = setInterval(() => calculateExpiryDate(), 250);
      }
    };

    start();
    return () => reset();
  }, [expiryTimestamp, timestamp, onExpire, calculateExpiryDate]);

  const stopTimer = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  return {
    days,
    hours,
    minutes,
    seconds,
    miliseconds,
    stopTimer
  };
};

export default useCountdown;
